import React from "react";

function Bar({score}){
  const pct=(score/5)*100;
  const c=pct>=70?"#43a047":pct>=50?"#fb8c00":"#e53935";
  return <div style={{flex:1,height:6,background:"#ede9e1",borderRadius:3,overflow:"hidden"}}><div style={{height:"100%",width:`${pct}%`,background:c,borderRadius:3}}/></div>;
}

function internet(c){
  const m={fiber:5,good:4,moderate:3,poor:2,limited:1};
  const n={fiber:"Glasvezel beschikbaar",good:"Goede breedbanddekking",moderate:"Redelijk, in ontwikkeling",poor:"Beperkt, 4G als backup",limited:"Alleen 4G/LTE"};
  const s=m[c?.internet_class]??3;
  return {score:s,note:c?.internet_note||n[c?.internet_class]||"Basis 4G beschikbaar"};
}
function healthcare(c){
  const sv=c?.scores?._services_osm;
  let s=3;
  if(sv) s=sv.hospital>0?5:sv.clinic>1?4:sv.clinic>0?3:2;
  else if(c?.healthcare_note?.toLowerCase().includes("ziekenhuis")) s=4;
  return {score:s,note:c?.healthcare_note||(s>=5?"Ziekenhuis aanwezig":s>=4?"Kliniek + ziekenhuis nabij":s>=3?"Huisarts/kliniek beschikbaar":"Ziekenhuis > 30 km")};
}
function expat(c){
  const m={high:5,medium:4,low:3,minimal:2,none:1};
  const s=m[c?.expat_density]??3;
  const p=c?.foreign_residents_pct;
  return {score:s,note:p?`${p}% buitenlanders geregistreerd`:s>=5?"Grote actieve expat-community":s>=4?"Goede expat-community, NL-groepen actief":s>=3?"Kleine internationale groep":"Weinig expats, lokale oriëntatie"};
}
function integratie(c){
  const m={high:5,medium:4,low:3,minimal:2};
  const s=Math.min(5,m[c?.expat_density]??3);
  const n={5:"Engels breed geaccepteerd, NL-community aanwezig",4:"Engelstalig netwerk beschikbaar",3:"Portugees B1 aanbevolen",2:"Lokaal gericht — Portugees noodzakelijk"};
  return {score:s,note:n[s]||"Portugees aanbevolen"};
}
function kosten(c){
  const tbl=[["algarve",2],["costa de lisboa",2],["sintra",2],["cascais",2],["porto",3],["setúbal",3],["alentejo",4],["centro",4],["costa vicentina",4],["norte",4]];
  let s=3;
  const r=(c?.region||"").toLowerCase();
  for(const[k,v] of tbl){if(r.includes(k)){s=v;break;}}
  const n={1:"Duurder dan NL",2:"Vergelijkbaar met NL",3:"10–20% goedkoper",4:"20–35% goedkoper",5:"Aanzienlijk goedkoper"};
  return {score:s,note:n[s]+(c?.imi_rate_2025?` · IMI ${c.imi_rate_2025}%/jr`:"")};
}

export function ExpatLeefbaarheid({concelho}){
  if(!concelho) return null;
  const factors=[
    {icon:"🌐",label:"Internet",...internet(concelho)},
    {icon:"🏥",label:"Gezondheidszorg",...healthcare(concelho)},
    {icon:"👥",label:"Expat-community",...expat(concelho)},
    {icon:"🗣️",label:"Integratie NL→PT",...integratie(concelho)},
    {icon:"💶",label:"Kosten vs NL",...kosten(concelho)},
  ];
  const avg=factors.reduce((s,f)=>s+f.score,0)/factors.length;
  const ov=Math.round(avg*10)/10;
  const bc=ov>=4?"#43a047":ov>=3?"#fb8c00":"#e53935";
  const bl=ov>=4?"Uitstekend geschikt":ov>=3?"Goed leefbaar":"Uitdagend";
  return (
    <section className="tm-section">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <h4 className="tm-section-h4" style={{margin:0}}>🧭 Leefbaarheid voor Nederlanders</h4>
        <span style={{fontSize:11,fontWeight:600,color:bc,background:bc+"18",padding:"3px 10px",borderRadius:20,flexShrink:0}}>{bl}</span>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:9}}>
        {factors.map(f=>(
          <div key={f.label}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2}}>
              <span style={{fontSize:15,width:22,textAlign:"center",flexShrink:0}}>{f.icon}</span>
              <span style={{width:140,fontSize:12,color:"#555",fontWeight:500,flexShrink:0}}>{f.label}</span>
              <Bar score={f.score}/>
              <span style={{fontSize:11,color:"#aaa",width:26,textAlign:"right",flexShrink:0}}>{f.score}/5</span>
            </div>
            <div style={{paddingLeft:30,fontSize:11,color:"#aaa",lineHeight:1.3}}>{f.note}</div>
          </div>
        ))}
      </div>
      <div style={{marginTop:12,padding:"9px 12px",background:"#f7f4ef",borderRadius:8,fontSize:11,color:"#666",lineHeight:1.5}}>
        <strong>💡 </strong>{ov>=4?"Uitstekend geschikt voor Nederlandse emigranten — goede infrastructuur, actieve community en gunstige kosten.":ov>=3?"Goed leefbaar. Verdiep je in internet/zorg en bouw een lokaal netwerk op.":"Relatief uitdagend — plan zorgvuldig en wees realistisch over taal en zorg."}
      </div>
    </section>
  );
}
